export default "__VITE_ASSET__$4k_OLgt__"